
function simulateMouseDown(el){
    var $el = $(el);
    var offset = $el.offset();
    console.debug(offset);
    var event = $.extend( $.Event( "mousedown" ), {
        which: 1,
        clientX: 2,
        clientY: 2,

                pageX: offset.left,
                pageY: offset.top
    });
    $el.trigger(event);
}

window.simulateMouseDown=simulateMouseDown;


